/* Moralis */
// docs api: https://docs.moralis.io/reference/gettokenprice-1
export const MORALIS_APP_API = 'https://deep-index.moralis.io/api/v2'
export const MORALIS_APP_API_KEY = '3EwdfGDMjcl235uf6DZIniUEIY6rZmbnY6tAWLDeSMFm2r4BW0QgyEG1NelJJNLZ'
export const MORALIS_APP_URL = 'https://zh59rm5t5l4j.usemoralis.com:2053/server'
export const MORALIS_APP_ID = 'W0kUA0Xr59ZG6M03m4jZj8BfE89qwMIgLiaxldk9'
